import { Component, Input, OnInit } from '@angular/core';
import { ballotTypeRecord } from '../../models/ballot-base/ballot-type';
@Component({
    selector: 'app-header-ballot-type',
    templateUrl: './header-ballot-type.component.html',
    styleUrl: './header-ballot-type.component.scss',
    standalone: false
})
export class HeaderBallotTypeComponent implements OnInit{
  @Input() ballotType: string = '';
  ballotTypeLabel: string = '';


  ngOnInit(): void {
    this.ballotTypeLabel = this.getBallotTypeLabel();
  }

  getBallotTypeLabel(): string {
    return ballotTypeRecord[this.ballotType] ?? ''
  }
}


